export enum ComparisonType {
    VERSION = 'version',
    CHANNEL = 'channel',
    VISUALS = 'visuals',
}

export enum ComparisonDifferenceMode {
    ADDED = 'added',
    DELETED = 'deleted',
    REMOVED = 'removed',
    MODIFIED = 'modified',
    UNCHANGED = 'unchanged',
    REORDERED = 'reordered',
}
